import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params, rootGetters) {
  const currencyId =
    rootGetters['User/getUserInfoFromState']?.organization?.currencyId || 1

  const tmpShipData = params.shipData.map((ele) => {
    const rackNum = ele.rackNumberList
      .filter((ele2) => ele2.count > 0)
      .map((ele2) => {
        return {
          // 出庫は負にする
          productStockAdjustQuantity: ele2.count * -1,
          rackNumber: commonUtil.nullEmptyFormatNull(ele2.rackNumber)
        }
      })
    return {
      productId: ele.productId,
      price: '0',
      currencyId,
      rackNumberList: rackNum
    }
  })
  const tmpLoadingData = params.loadingData.map((ele) => {
    const rackNum = ele.rackInfoList
      .filter((ele2) => ele2.quantity > 0)
      .map((ele2) => {
        return {
          productStockAdjustQuantity: ele2.quantity,
          rackNumber: commonUtil.nullEmptyFormatNull(ele2.rackNumber)
        }
      })
    return {
      productId: ele.productId,
      productLotNumber: commonUtil.nullEmptyFormatNull(ele.productLotNumber),
      productExpiredDate: commonUtil.nullEmptyFormatNull(
        ele.productExpiredDate
      ),
      rackNumberList: rackNum,
      price: ele.productPrice !== '*****' ? ele.productPrice : '0',
      currencyId: ele.productCurrency.value
    }
  })
  const stockAdjustProductList = tmpShipData
    .filter((ele) => ele.rackNumberList.length > 0)
    .concat(tmpLoadingData.filter((ele) => ele.rackNumberList.length > 0))

  return {
    adjustStorageId: params.clientData.clientInfo.storageId,
    adjustReasonId: params.clientData.invoiceInfo.storageAdjustReason.value,
    target: commonUtil.nullEmptyFormatNull(
      params.clientData.invoiceInfo.storageAdjustReasonTarget
    ),
    recipientCountryId: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.country.value
    ),
    recipientPostalCode: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.postalCode
    ),
    recipientRegionId: commonUtil.formatRegion(
      params.clientData.receiverInfo.region,
      true
    ),
    recipientRegion: commonUtil.formatRegion(
      params.clientData.receiverInfo.region,
      false
    ),
    recipientAddress1: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.address1
    ),
    recipientAddress2: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.address2
    ),
    recipientPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.phone.countryCode.value
    ),
    recipientPhoneNumber: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.phone.phoneNumber
    ),
    recipientName: commonUtil.nullEmptyFormatNull(
      params.clientData.receiverInfo.fullName
    ),
    trackingNumber: commonUtil.nullEmptyFormatNull(
      params.clientData.invoiceInfo.trackingNumber
    ),
    stockAdjustDate: params.clientData.invoiceInfo.storageMoveDate,
    stockAdjustProductList: stockAdjustProductList,
    note: commonUtil.nullEmptyFormatNull(params.remarks)
  }
}
export default { request }
